var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTriangleWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3869 10.2198L10.0002 1.71317C9.54689 1.05984 8.79356 0.666504 8.00023 0.666504C7.20689 0.666504 6.45356 1.05317 5.98023 1.73317L0.620227 10.2065C-0.0597729 11.1798 -0.18644 12.3465 0.286894 13.2465C0.75356 14.1465 1.73356 14.6598 2.96023 14.6598H13.0402C14.2736 14.6598 15.2469 14.1465 15.7136 13.2465C16.1802 12.3465 16.0536 11.1865 15.3869 10.2198ZM7.33356 4.6665C7.33356 4.29984 7.63356 3.99984 8.00023 3.99984C8.36689 3.99984 8.66689 4.29984 8.66689 4.6665V8.6665C8.66689 9.03317 8.36689 9.33317 8.00023 9.33317C7.63356 9.33317 7.33356 9.03317 7.33356 8.6665V4.6665ZM8.00023 12.6665C7.44689 12.6665 7.00023 12.2198 7.00023 11.6665C7.00023 11.1132 7.44689 10.6665 8.00023 10.6665C8.55356 10.6665 9.00023 11.1132 9.00023 11.6665C9.00023 12.2198 8.55356 12.6665 8.00023 12.6665Z",
    fill: "#CC9A06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleWarning);
export default __webpack_public_path__ + "static/media/triangle-warning.718b15b0dca1182a65e4b8469f2ab12c.svg";
export { ForwardRef as ReactComponent };